<script setup>
import ChartLabelDot from '@/components/svg/ChartLabelDot.vue'
import VueApexCharts from 'vue3-apexcharts'

// 사주풀이>오행분포 차트

const props = defineProps({
  fiveChardData: Object,
  fiveChardDesc: String,
  isMobile: Boolean,
  chartColor: Object,
})


const labels = ['희신', '구신', '기신', '한신', '용신']
const fiveElementHanja = {
  목: '木',
  화: '火',
  토: '土',
  금: '金',
  수: '水',
}

const customLabels = computed(() => {
  return labels.map(label => {
    const element = props.chartColor?.[label] || ''
    const hanja = fiveElementHanja[element] || ''
    return `${label}오행 ${hanja}`
  })
})

const series = computed(() => {
  if (!props.fiveChardData || !labels) return []
  return labels.map(label => props.fiveChardData[label] ?? 0)
})

const fiveElementColors = {
  목: 'rgba(var(--v-theme-fiveColor03), 1)',
  화: 'rgba(var(--v-theme-fiveColor01), 1)',
  토: 'rgba(var(--v-theme-fiveColor05), 1)',
  금: 'rgba(var(--v-theme-fiveColor04), 1)',
  수: 'rgba(var(--v-theme-fiveColor02), 1)',
}
const colors = computed(() => {
  return labels.map(label => {
    const element = props.chartColor?.[label]
    const color = fiveElementColors[element]
    return color || '#000'
  })
})


const chartOptions = computed(() => ({
  chart: {
    type: 'donut',
    height: 180,
    width: 180,
    parentHeightOffset: 0,
  },
  labels,
  colors: colors.value,
  stroke: {
    width: 0,
  },
  legend: {
    show: false,
  },
  plotOptions: {
    pie: {
      donut: {
        size: '50%',
        labels: {
          show: true,
          value: {
            show: true,
            fontSize: '14px',
            fontFamily: 'Pretendard',
            fontWeight: 500,
            color: colors.value,
          },
          total: {
            show: false,
          },
        },
      },
    },
  },
  dataLabels: {
    enabled: true,
    formatter: (val, opts) => opts.w.config.series[opts.seriesIndex],
    dropShadow: {
      enabled: false,
    },
    style: {
    fontSize: '12px',
    fontFamily: 'Pretendard',
    fontWeight: '700',
    colors: ['#fff'],
  },
  },
  tooltip: {
    enabled: false,
  },
}))
</script>
<template>
  <div class="five-chart__wrapper"
  :class="[{mobile: isMobile}]"
  >
    <VueApexCharts
      :options="chartOptions" 
      :series="series" 
      type="donut" 
      :height="180" 
      :width="180"
    />
    <div class="five-chart__legend">
      <div
        v-for="(label, idx) in customLabels"
        :key="idx"
        class="chart-label"
        :class="`color-${idx}`"
      >
      <ChartLabelDot :color="colors[idx]" />
      <span class="chart-label__legend" :style="{ color: colors[idx] }">
        {{ label }}
      </span>
      <span class="chart-label__value" :style="{ color: colors[idx] }">
        {{ fiveChardData[labels[idx]] }}
      </span>
    </div>
    </div>
  </div>

</template>
<style scoped>
.five-chart__desc.mobile{
  text-align: center;
}
</style>